import type { ItemFieldEntry } from '@cheqroom/api';

/** Filters and reorders raw field definitions down to the given ids, in that order. Unmatched ids
 * are skipped. Used by callers to build `ItemInfo`'s `fieldDefs` from `getItemFields()`'s full,
 * unfiltered output. */
export const selectFieldDefs = (defs: readonly ItemFieldEntry[], ids: string[]): ItemFieldEntry[] => {
	const byId = new Map(defs.map((def) => [def.id, def]));
	return ids.map((id) => byId.get(id)).filter((def): def is ItemFieldEntry => def != null);
};
